<div
    *ngIf="shouldRender(element, language)"
    id="{{ element.id }}"
    [ngClass]="getComponentCssClasses(element.id)"
    [attr.data-e2e]="'html-' + element.id"
>
    <div #html [innerHtml]="sanitizedHtml"></div>
</div>
